<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>Training Certificates Needing Review </h1>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <div *ngIf="!validForm" class="row">
                <div class="alert danger">
                    <p><em>Error Message:</em></p>
                    <ul>
                        <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <div class="training-certi-list">
        <div class="titles">
            <span><strong>Login ID</strong></span>
            <span><strong>User Name</strong></span>
            <span><strong>NPN</strong></span>
            <span><strong>User Status</strong></span>
            <span><strong>PDF</strong></span>
        </div>
        <ul>
            <li *ngFor="let userProfileTrainingCertificate of userProfileTrainingCertificates">
                <div class="lists" *ngIf="userProfileTrainingCertificate.CreditAppliedStatus=='P'">
                    <!--<span><a (click)="updateCourses(userProfileTrainingCertificate)">{{userProfileTrainingCertificate.UserProfileName}}</a></span>-->
                    <span><a (click)="loadingupdateCourses(userProfileTrainingCertificate)">{{userProfileTrainingCertificate.UserProfileName}}</a></span>
                    <span>{{userProfileTrainingCertificate.FirstName + ' '+userProfileTrainingCertificate.LastName}}</span>
                    <span>{{userProfileTrainingCertificate.NIPR!='' ? userProfileTrainingCertificate.NIPR :' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}}</span>
                    <span>{{userProfileTrainingCertificate.UserProfileStatusCode}}</span>
                    <span>
                        <a (click)="showCertificate(userProfileTrainingCertificate.UserProfileTrainingCertificateID)"><img alt="pdf" src="data:image/svg+xml;charset=utf8;base64,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" /></a>
                    </span>
                </div>
                <div [hidden]="loading">
                    <div class="course-details" *ngIf="!innerloading && selectedUserProfile && selectedUserProfile==userProfileTrainingCertificate">
                        <div class="row">
                            <div class="col-24">
                                <div class="botom-20">
                                    <div *ngIf="currentYearCourses?.length" class="year-container">
                                        <input type="checkbox" class="centered-checkbox"
                                               id="currentYear"
                                               value="currentYear"
                                               [checked]="selectedYear1"
                                               (click)="onselectedYear1Check()" />
                                        <label for="currentYear"> {{currentYear}}</label>
                                        <div *ngIf="currentYearCourses?.length" class="courses-list-container">
                                            <training-courses-list class="courses-list" [courses]="currentYearCourses"></training-courses-list>
                                        </div>

                                    </div>
                                    <div *ngIf="!nextYearErrored && nextYearCourses?.length" class="year-container">
                                        <input type="checkbox" class="centered-checkbox"
                                               id="nextYear"
                                               value="nextYear"
                                               [checked]="selectedYear2"
                                               (click)="onselectedYear2Check()" />
                                        <label for="nextYear"> {{nextYear}}</label>


                                        <div *ngIf="nextYearCourses?.length" class="courses-list-container">
                                            <training-courses-list class="courses-list" [courses]="nextYearCourses"></training-courses-list>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-24">
                                <button class="button primary" [disabled]="this._global.currentUser.isAuditor" (click)="applyCredits()">Apply Credits</button>
                                <button class="button primary" [disabled]="this._global.currentUser.isAuditor" (click)="inValid()">Invalid Certificate</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </li>
        </ul>
    </div>

</div>